// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"31a6910d","942":"c3a88805"}[chunkId] + ".chunk.js";
};